// Web-specific PKCE state stash. Pure verifier generation/digest live in
// @repo/auth-core; this module owns the sessionStorage handoff between the
// redirect to Cognito and the /login callback.

export { challengeFromVerifier, generateVerifier } from "@repo/auth-core";

const VERIFIER_KEY = "tailspend.pkce.verifier";
const STATE_KEY = "tailspend.pkce.state";
const RETURN_TO_KEY = "tailspend.pkce.returnTo";

export function rememberVerifier(
  verifier: string,
  state: string,
  returnTo: string,
): void {
  sessionStorage.setItem(VERIFIER_KEY, verifier);
  sessionStorage.setItem(STATE_KEY, state);
  sessionStorage.setItem(RETURN_TO_KEY, returnTo);
}

export interface PendingVerifier {
  verifier: string;
  state: string;
  returnTo: string;
}

/**
 * Reads the in-flight verifier without removing it. Callers must call
 * `clearVerifier()` *after* validating the OAuth callback so a transient
 * mismatch (parallel tab raced us, user reloaded `/login`) doesn't strand
 * the user with no way to retry.
 */
export function peekVerifier(): PendingVerifier | null {
  const verifier = sessionStorage.getItem(VERIFIER_KEY);
  const state = sessionStorage.getItem(STATE_KEY);
  const returnTo = sessionStorage.getItem(RETURN_TO_KEY);
  if (verifier === null || state === null || returnTo === null) return null;
  return { verifier, state, returnTo };
}

export function clearVerifier(): void {
  sessionStorage.removeItem(VERIFIER_KEY);
  sessionStorage.removeItem(STATE_KEY);
  sessionStorage.removeItem(RETURN_TO_KEY);
}
